// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogFAQ_container__vgwLu","questions":"BlogFAQ_questions__HGFsQ","heading":"BlogFAQ_heading__soD8L","categoryIcon":"BlogFAQ_categoryIcon__POumM"};